import { Component, Input } from '@angular/core';
import { IconEnum } from 'shared/design-system/data-access/icon';
import { RemSize } from 'shared/design-system/data-access/layout';
import { ColorEnum } from 'shared/design-system/data-access/theme';
import { IconComponent } from 'shared/design-system/ui/typography';

@Component({
    selector: 'it-spinner',
    imports: [IconComponent],
    templateUrl: './spinner.component.html',
    styleUrls: ['spinner.component.scss'],
})
export class SpinnerComponent {
    @Input() color?: ColorEnum;
    @Input() fontSize?: RemSize;

    IconEnum = IconEnum;
}
